module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-0a7f289b50eb9aa672c46c6533209435.png";